import { atom } from "recoil";

import { SubscribersTotal } from "../models";

export const subscribersTotalAtom = atom({
    key: "subscribersTotalAtom",
    default: new Map<SubscribersTotal, number>().set(SubscribersTotal.Previous, 0).set(SubscribersTotal.Current, 0),
});
